import type { NewsArticle } from './newsData';

export const newsArchive2022: NewsArticle[] = [
  {
    slug: 'essential-course-opening-guide-202203',
    date: '2022年3月8日',
    category: 'update',
    categoryLabel: '更新情報',
    title: '修了実技試験で評価する観点と、再試験をどう位置づけているか',
    metaDescription:
      '修了実技試験では所作の正確さだけでなく状況判断と静かな対応力を見ます。出席率80％以上を前提に、評価の観点・当日の流れ・再試験1回無料の扱いを具体的に整理しました。協会認定資格につながる基準を知る入口としてお読みください。',
    keywords: ['修了実技試験', '評価観点', '再試験', '協会認定資格', '出席率'],
    heroImage: '/images/generated/training-basic-2026.jpg',
    heroAlt: '実技試験を想定した立ち居振る舞いの確認風景',
    figures: [
      {
        src: '/images/generated/essential-manners-2026.jpg',
        alt: '試験課題に近いテーブルマナー実技の手元',
        caption: '評価は型の再現だけでなく、場の空気を乱さない運び方まで含みます',
      },
    ],
    overview: {
      heading: '修了実技試験の要点',
      rows: [
        { label: '受験条件', value: '出席率80％以上（各コース共通）' },
        { label: '評価の柱', value: '所作／状況判断／言葉遣い／静かな対応' },
        { label: '再試験', value: '1回無料（日程は個別調整）' },
        { label: '授業単位', value: '1日6時間（90分×4コマ）・土日開催' },
        { label: '定員の前提', value: '各コース定員6名・最少催行3名' },
      ],
    },
    faq: [
      {
        question: '試験は一発勝負ですか？',
        answer:
          'いいえ。所定の基準に届かなかった場合は再試験を1回無料で受けられます。弱点の洗い出しと短い補習を挟んでから再挑戦する運用です。',
      },
      {
        question: '何を一番重視して見ていますか？',
        answer:
          '型の正確さに加え、相手の間を奪わない判断と、声量・視線・立ち位置の落ち着きです。派手な演技より、静かに場を整える力を評価します。',
      },
    ],
    related: [
      { title: '修了・認定', desc: '試験と資格授与の流れ', href: '/certificate' },
      { title: 'カリキュラム', desc: '実技が積み上がる順序', href: '/curriculum' },
      { title: 'コース一覧', desc: '3コースそれぞれの到達点', href: '/courses' },
      { title: '資料請求（無料）', desc: '試験概要を含む案内冊子', href: '/brochure' },
    ],
    body: `<p>修了実技試験は、教科書の暗記量を測る場ではありません。お台場本校で積み重ねた所作が、想定外の小さな変化にも耐えられるかを見る最終確認です。エッセンシャル・アドバンス・マスターのいずれでも、出席率80％以上を満たしたうえで受験していただきます。</p>
<h2>評価で見ている四つの層</h2>
<p>第一に、立ち方・歩き方・物の渡し方など基礎所作の再現性です。第二に、来客の人数やタイミングが変わったときの状況判断。第三に、敬語の選択と声の大きさ。第四に、失敗した瞬間に慌てず軌道修正できる静けさです。点数表は項目ごとに分かれますが、現場ではこれらが同時に動くため、部分点の合計だけでなく全体の印象も総合します。</p>
<h2>当日の流れと課題の組み立て</h2>
<p>試験日は通常授業と同じく、90分×4コマを意識した時間配分で進行します。前半は単独課題（入場、案内、給仕の基本動作）、後半は短いロールプレイです。教科書全15冊からまんべんなく出題するのではなく、コースごとに到達すべき核だけを抜き出します。少人数（定員6名・最少催行3名）だからこそ、観察者は一人ひとりの手元と視線の移動まで追えます。</p>
<h2>再試験を「やり直し」ではなく「仕上げ」にする</h2>
<p>基準に届かなかった場合の再試験は1回無料です。不合格の通知だけで終わらせず、どの層が薄かったかを短くフィードバックし、必要なら補習コマを挟みます。再試験は罰則ではなく、現場に出る前の仕上げと位置づけています。合格後に協会認定資格の授与手続きへ進むため、焦って形だけ通す運用は採りません。</p>
<p>試験対策だけを急ぐより、日々の実技で「見られている前提」に慣れることが最短です。評価観点の詳細資料が必要な方は、入学案内や修了・認定のページもあわせてご確認ください。</p>`,
  },
  {
    slug: 'seminar-consultation-guide-202207',
    date: '2022年7月16日',
    category: 'schedule',
    categoryLabel: '開校情報',
    title: '働きながら通う受講生の一週間——土日通学とオンデマンドの分け方',
    metaDescription:
      '仕事を続けながら執事を学ぶ人の一週間を、土日の通学実技と平日オンデマンドの役割分担で紹介します。1日6時間・定員6名の节奏に合わせた復習の置き方、疲れを残さない準備のコツまで具体例でまとめました。',
    keywords: ['働きながら学ぶ', '土日通学', 'オンデマンド', '受講生の一週間', '両立の工夫'],
    heroImage: '/images/generated/facilities-hero-2026.jpg',
    heroAlt: '仕事帰りでも集中しやすいお台場本校の講義空間',
    figures: [
      {
        src: '/images/generated/about-classroom-2026.jpg',
        alt: '少人数で進行する土日実技の教室',
        caption: '実技は土日に固め、知識の反復は平日の短い枠へ移します',
      },
    ],
    overview: {
      heading: '両立学習の基本フレーム',
      rows: [
        { label: '通学', value: '土日開催・1日6時間（90分×4コマ）' },
        { label: '平日', value: 'オンデマンドでの要点復習・ノート整理' },
        { label: 'クラス規模', value: '定員6名・最少催行3名' },
        { label: '教材', value: '教科書全15冊を週単位で区切って使用' },
        { label: '会場', value: 'お台場本校' },
      ],
    },
    faq: [
      {
        question: '平日にまとまった勉強時間が取れなくても大丈夫ですか？',
        answer:
          '大丈夫です。平日は20〜40分の短い枠を二回に分けるだけでも効果があります。土日の実技で身体を動かし、平日は用語と手順の確認に徹する分け方が現実的です。',
      },
      {
        question: 'オンデマンドだけで修了できますか？',
        answer:
          'できません。修了実技試験と協会認定資格は対面での到達確認が前提です。オンデマンドは通学で得た型を忘れないための補助とお考えください。',
      },
    ],
    related: [
      { title: 'コース一覧', desc: '生活リズムに合う課程を比較', href: '/courses' },
      { title: '入学案内', desc: '申込から初回通学までの手順', href: '/admission' },
      { title: '料金', desc: '受講料と支払いの確認', href: '/pricing' },
      { title: 'アクセス', desc: 'お台場本校への経路', href: '/access' },
    ],
    body: `<p>「平日はフルタイム、週末だけ本校へ」——当校の受講生の多くがこの形です。2022年時点で見えてきたのは、気合で毎日長時間机に向かう人より、役割を分けた人のほうが実技の定着が早いという事実でした。以下は、実際の時間割を抽象化した一週間のモデルです。</p>
<h2>土日にしか置かないもの</h2>
<p>立ち居振る舞い、案内動線、食卓サービスなど、身体の感覚が必要な内容は土日に集中させます。1日6時間（90分×4コマ）は長く感じられますが、コマのあいだに短い振り返りを挟むため、後半でも手が止まらない設計です。定員6名の教室では、講師が巡回して握り方や歩幅のズレをその場で戻せます。ここをオンデマンドに置き換えると、自己流が固定されるリスクが高まります。</p>
<h2>平日オンデマンドの使い方</h2>
<p>平日は教科書全15冊のうち、その週に触れた章だけを短く見直します。推奨は通勤前後の20分＋就寝前の15分です。動画は倍速視聴より、一時停止して自分の手で空振りする回数が成果に直結します。メモは綺麗なノートより、「試験で聞かれそうな判断ポイント」を三行だけ残す方が翌週末に生きます。</p>
<h2>疲れを翌週に持ち越さない工夫</h2>
<p>日曜夜に完璧な復習を目指すと、翌週の仕事効率が落ちます。代わりに、帰路で「今日いちばん崩れた動作」を一つだけ思い出し、月曜の短い枠でそこだけ再生する。この単点集中が、最少催行3名から始まる小さなクラスでも互いの進度差を広げにくくします。コースがエッセンシャルでもアドバンスでもマスターでも、両立の骨格は同じです。</p>
<p>生活パターンに合わせた通学計画の相談は随時受け付けています。初回の土日に何を持参すべきか迷う場合は、入学案内のチェックリストを先に眺めてから問い合わせると話が早く進みます。</p>`,
  },
  {
    slug: 'materials-curriculum-update-202211',
    date: '2022年11月12日',
    category: 'seminar',
    categoryLabel: '説明会',
    title: '授業で扱う「守秘」——執事の沈黙を技術として学ぶ',
    metaDescription:
      '執事に不可欠な守秘を、精神論ではなく授業内の演習としてどう扱うかを解説します。会話の境界線、記録の残し方、同席時の立ち位置まで、お台場本校の少人数クラスで行う具体的な学び方を公開します。',
    keywords: ['守秘', 'プライバシー', '執事の倫理', '授業演習', '沈黙の技術'],
    heroImage: '/images/generated/essential-writing-2026.jpg',
    heroAlt: '記録と書簡の扱いを確認する授業の手元',
    figures: [
      {
        src: '/images/generated/essential-napkin-2026.jpg',
        alt: '静かなサービス動線を保つ実技の場面',
        caption: '守秘は口だけでなく、動作と距離感にも表れます',
      },
    ],
    overview: {
      heading: '守秘を学ぶ授業の枠組み',
      rows: [
        { label: '扱い方', value: '倫理講義＋ロールプレイ演習' },
        { label: '関連教材', value: '教科書全15冊のうち実務・倫理章' },
        { label: 'クラス', value: '定員6名・最少催行3名' },
        { label: '実施場所', value: 'お台場本校' },
        { label: '到達確認', value: '修了実技試験の状況判断課題に反映' },
      ],
    },
    faq: [
      {
        question: '守秘はマナー講座の延長ですか？',
        answer:
          'いいえ。挨拶や席次とは別に、情報の境界を設計する技術として扱います。誰に何を話さないかだけでなく、聞かれ方への返し方まで演習します。',
      },
      {
        question: '現場ごとのルールの違いはどう教えますか？',
        answer:
          '家庭・法人・行事など場面を分け、共通して守る核と、雇用側の方針で上書きされる部分を区別して提示します。盲従ではなく判断の軸を渡すのが目的です。',
      },
    ],
    related: [
      { title: 'カリキュラム', desc: '倫理と実技の配置を確認', href: '/curriculum' },
      { title: '教材について', desc: '倫理章を含む全15冊の構成', href: '/materials' },
      { title: '修了・認定', desc: '状況判断が試される試験', href: '/certificate' },
      { title: '説明会・セミナー', desc: '学び方を直接質問できる場', href: '/seminar' },
    ],
    body: `<p>執事の価値は、見えるサービスだけで決まりません。家庭や組織の内側に入る以上、「知っていても語らない」姿勢が信頼の土台になります。当校では守秘を精神訓話で終わらせず、授業の演習課題として扱います。2022年冬の説明会でも、この単元の進め方を重点的にお伝えしています。</p>
<h2>沈黙を「何もしないこと」と誤解しない</h2>
<p>守秘は口を閉ざすだけではありません。話題を別の安全な層へ移す、記録を最小限にする、第三者の前での表情管理を行う——いずれも技術です。教科書全15冊のうち実務と倫理に関する章では、良い沈黙と、必要な報告を怠る沈黙の違いを事例で対比します。受講生同士が定員6名の輪の中で役割を交代し、漏らしてはいけない情報を渡された側の緊張を体感します。</p>
<h2>ロールプレイで使う三つの場面</h2>
<p>一つ目は来客応対で私的な予定を聞かれたとき。二つ目は電話口で家族構成を探られたとき。三つ目は行事準備中に取引先へ余分な背景を話しそうになったときです。1日6時間（90分×4コマ）の枠内で、同じ場面を二度演じ、一度目は失敗パターン、二度目は修正パターンを共有します。最少催行3名からでも成立するよう、観察役を必ず置くのが特徴です。</p>
<h2>記録・デジタル・立ち位置まで含める</h2>
<p>紙のメモ、共有カレンダー、写真の扱いも授業内で触れます。残す必要がある情報と、頭の中だけに置く情報を分ける判断を、チェックリストではなく原則で渡します。また、会話の輪の外に立つ位置や、書類を開く角度といった身体的な守秘も実技に組み込み、修了実技試験の状況判断課題へつなげます。協会認定資格は技能証明であると同時に、この判断軸を身につけた証でもあります。</p>
<p>守秘単元のデモを体験したい方は、説明会で演習の短縮版を実施する回があります。日程はセミナーページで告知し、個別の疑問は連絡フォームから事前に投げていただくと当日の配分を調整できます。</p>`,
  },
  {
    slug: 'master-course-winter-intake-202202',
    date: '2022年2月14日',
    category: 'schedule',
    categoryLabel: '開校情報',
    title: '管理と危機対応を軸に据える——マスターコース2月開校クラス',
    metaDescription:
      '2022年2月、お台場本校でマスターコースを開校します。3ヶ月16日間96時間で管理と危機対応を修める最上位課程です。定員6名・土日開催・出席率80％以上と修了実技試験の条件、申込締切と選考の流れをまとめました。',
    keywords: ['マスターコース', '2月開校', '危機対応', '管理実務', '協会認定資格'],
    heroImage: '/images/generated/master-table-2026.jpg',
    heroAlt: '高度なテーブルサービスを想定したマスター課程の実技',
    figures: [
      {
        src: '/images/generated/master-service-2026.jpg',
        alt: '複数動線を同時に整える上級実技の様子',
        caption: '管理視点の演習では、自分の手元だけでなく場全体の流れを見ます',
      },
    ],
    overview: {
      heading: '2022年2月マスターコース概要',
      rows: [
        { label: '開校月', value: '2022年2月（土日開催）' },
        { label: '期間・時間', value: '3ヶ月・16日間・96時間' },
        { label: '1日の構成', value: '6時間（90分×4コマ）' },
        { label: '定員', value: '6名（最少催行3名）' },
        { label: '修了条件', value: '出席率80％以上＋修了実技試験' },
      ],
    },
    faq: [
      {
        question: 'アドバンス未修了でも申し込めますか？',
        answer:
          '原則としてアドバンス相当の実技基盤がある方を対象にしています。面談で到達度を確認し、不足が大きい場合は先に下位課程をご案内します。',
      },
      {
        question: '申込はいつまでにすればよいですか？',
        answer:
          '開校日の10日前を一次締切とします。定員6名に達した時点で受付を閉じるため、書類が揃い次第の提出を推奨します。',
      },
    ],
    related: [
      { title: 'コース一覧', desc: 'マスターの位置づけを比較', href: '/courses' },
      { title: 'カリキュラム', desc: '3ヶ月16日の単元配置', href: '/curriculum' },
      { title: '入学案内', desc: '面談と提出書類の手順', href: '/admission' },
      { title: '修了・認定', desc: '実技試験と資格授与', href: '/certificate' },
    ],
    body: `<p>2022年2月、お台場本校にてマスターコースを開校します。本課程は3コースの最上位に位置し、現場の「手を動かす力」に加え、人員配置・緊急時の優先順位・主人側との意思疎通までを一体で扱う回です。期間は3ヶ月、通学16日間、総96時間。いずれも土日に集め、1日6時間（90分×4コマ）で進めます。</p>
<h2>今期クラスが重点を置く二つの柱</h2>
<p>一つは管理です。来客が重なったときの動線設計、外部業者との受け渡し、当日変更への再配分を、定員6名の机上演習と実技の往復で磨きます。もう一つは危機対応です。器物の破損、来客の体調変化、機密に触れる会話の割り込みなど、想定を細かく分けて判断の順序を言語化します。教科書全15冊のうち上級章を軸に、下位課程で身につけた型を「誰に・どの順で」使うかに引き上げる構成です。</p>
<h2>学び方と到達の測り方</h2>
<p>毎回の後半コマに短い振り返りを置き、観察役と実施役を交代します。最少催行3名から開講しますが、人数が少ない回ほど一人あたりの判断回数が増える設計です。修了には出席率80％以上と修了実技試験が必要で、基準未達の場合は再試験を1回無料で受けられます。合格後は協会認定資格の授与手続きへ進みます。</p>
<h2>申込から初回までの流れ</h2>
<p>まず入学案内のフォームから希望日程を送り、面談枠を確定します。面談では職務経験の有無より、長時間の実技に耐える生活リズムと、管理役を引き受ける意思を確認します。受講料の確認は料金ページ、経路はアクセスページを参照のうえ、開校10日前までに必要書類を揃えてください。定員に達し次第、その月の受付は終了します。</p>
<p>最上位課程は知識の上積みではなく、静かに場を預かれないかの確認でもあります。今期の枠で管理と危機対応を仕上げたい方は、早めに面談予約を入れて日程のすり合わせを始めてください。</p>`,
  },
  {
    slug: 'essential-course-autumn-class-202209',
    date: '2022年9月3日',
    category: 'recruitment',
    categoryLabel: '募集情報',
    title: '秋からの第一歩——エッセンシャルコース9月生を受け付けます',
    metaDescription:
      '2022年9月開始のエッセンシャルコースを募集します。1ヶ月8日間48時間で基礎所作と接遇の型を身につける入門回です。お台場本校・土日・定員6名。締切は開校1週間前、体験セミナー経由の申込手順も記載しています。',
    keywords: ['エッセンシャルコース', '9月生', '秋開講', '入門課程', '募集'],
    heroImage: '/images/generated/course-essential-2026.jpg',
    heroAlt: '入門クラスで基礎立ち姿勢を揃える受講風景',
    figures: [
      {
        src: '/images/generated/first-lesson-2026.jpg',
        alt: '初回授業で名刺と挨拶の距離を測る様子',
        caption: '秋期は短い期間に基礎を圧縮するため、初回から手を動かす比重が高めです',
      },
    ],
    overview: {
      heading: '2022年9月エッセンシャル募集要項',
      rows: [
        { label: '開始', value: '2022年9月（秋期・土日）' },
        { label: '期間・時間', value: '1ヶ月・8日間・48時間' },
        { label: '授業単位', value: '1日6時間（90分×4コマ）' },
        { label: '定員', value: '6名（最少催行3名）' },
        { label: '会場', value: 'お台場本校' },
      ],
    },
    faq: [
      {
        question: '未経験でも秋期から始めて間に合いますか？',
        answer:
          '間に合います。エッセンシャルは前提技能を求めない入門課程です。初回に用語と立ち位置の共通理解を作り、2回目以降で手技の反復に入ります。',
      },
      {
        question: '募集はどのように閉じますか？',
        answer:
          '開校1週間前を締切とし、先着で定員6名に達した時点でも閉じます。最少催行3名に満たない場合は開始日を延期し、応募者へ個別連絡します。',
      },
    ],
    related: [
      { title: 'コース一覧', desc: '入門課程の到達点を確認', href: '/courses' },
      { title: '料金', desc: 'エッセンシャルの受講料', href: '/pricing' },
      { title: '説明会・セミナー', desc: '申込前に雰囲気を見る', href: '/seminar' },
      { title: '資料請求（無料）', desc: '時間割例付きの冊子', href: '/brochure' },
    ],
    body: `<p>2022年9月、お台場本校のエッセンシャルコース秋期クラスを開講します。初めて執事の型に触れる方向けの入門回で、期間は1ヶ月・通学8日間・総48時間です。夏の忙しさが一段落したあとから基礎を固めたい人に合わせ、すべて土日・1日6時間（90分×4コマ）に収めています。</p>
<h2>秋期入門で先に身につける範囲</h2>
<p>扱う中心は、立ち方・歩き方・挨拶・名刺と案内の距離感、そして静かな声量です。教科書全15冊のうち入門章を週ごとに区切り、知識の読み込みより「同じ動作を正確に繰り返す」時間を厚く取ります。定員6名のため、講師は握り方や足の向きのズレをその場で戻せます。アドバンスやマスターへ進む前提として、自己流を増やさないことが今期の目標です。</p>
<h2>申込の流れと締切の考え方</h2>
<p>申し込みは入学案内のフォームから受け付けます。不安が残る方は、先にセミナーで教室の空気を見てからでも構いません。必要事項の送信後、受付確認と初回持参物の一覧を返送します。締切は開校日の1週間前。ただし先着で定員に達した場合はその時点で募集を終えます。最少催行3名を下回るときは開始をずらし、候補日を個別に提示します。</p>
<h2>修了までの見通し</h2>
<p>出席率80％以上を満たしたうえで修了実技試験を受けます。評価は派手さより、動作の再現性と場を乱さない間合いです。届かなかった場合の再試験は1回無料です。合格後は協会認定資格の手続き案内へ進み、続けて上位課程を検討する方にはアドバンスの日程も併せてお伝えします。</p>
<p>秋から型を整えたい方にとって、1ヶ月48時間は短く濃い期間です。持ち物と料金の最終確認が済んだら、空き枠のあるうちに受付へ送ってください。経路が未確認の方はアクセスページでお台場本校までの所要時間もあわせてご覧ください。</p>`,
  },
];
